import { render, staticRenderFns } from "./change-plan.vue?vue&type=template&id=12fe37ee&scoped=true&"
import script from "./change-plan.vue?vue&type=script&lang=js&"
export * from "./change-plan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fe37ee",
  null
  
)

export default component.exports